/// <amd-module name="Test/ConfigurationToolbar/Actions/ConfigurationToolbarActions" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { Action } from "VSS/Reflux/Action";

export class ConfigurationToolbarActions {
    public updateConfigurationValuesAction: Action<CommonTypes.IReportConfiguration> = new Action<CommonTypes.IReportConfiguration>();
    public onToggleFilter: Action<null> = new Action<null>();
}
